import Button from "../common/button";


const UserPermissionsForm = (props) => {
  const {
    formTitle,
    hideTitle,
    submitLabel,
    submitAction,
    sendInviteField,
    children,
    disabled,
    hideAddRow,
    addAction
  } = props;

  return (
    <form className='user-permissions-form'>
      <div className='form-header'>
        <div className={hideTitle ? 'sr-hide' : 'form-title'}>{formTitle}</div>
      </div>
      <div className='form-body'>
        <div className='form-items'>
          {children}
          <div className={`form-add-row ${(hideAddRow === true) ? 'sr-hide' : ''}`}>
            <Button label='Add' action={() => addAction()}/>
          </div>
          <div className='form-buttons'>
            {sendInviteField && sendInviteField}
            <Button label={submitLabel} action={submitAction} disabled={disabled}/>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UserPermissionsForm;